/* eslint-disable @typescript-eslint/no-explicit-any */ // TODO: Remove this disable and fix all any types in this file
import { ShopArticleContext } from "@/shared/environment/widgets/widget-context";
import { ApolloCache, ApolloClient, NormalizedCacheObject } from "@apollo/client";

export namespace ShopCore {
    export enum Type {
        FDI = "fdi",
        SWAROVSKI = "swarovski",
        BOBST = "bobst",
        SHOP_LIGHT = "shop-light",
        /** Provider-agnostic shop served through the InfoTwin shop service (QIT-6603). */
        GENERIC = "generic",
    }

    export interface ItemInfo {
        price: number | null;
        showPriceOnRequest: boolean;
        amountAvailable: number;
        stockStatus: number;
        currencySign: string;
    }

    export enum StockStatus {
        AVAILABLE = "available",
        LOW_STOCK = "low_stock",
        OUT_OF_STOCK = "out_of_stock",
        UNAVAILABLE = "unavailable",
    }

    export interface WidgetItem {
        price: {
            amount: number | null;
            currency?: string;
            currencySign?: string;
            onRequestOnly: boolean;
        };
        stock: {
            available: StockStatus;
            quantity: number;
        };
        /**
         * Whether the shop accepts an order for this article, as reported by the
         * shop itself (generic shop `ShopItemInfo.orderable`, QIT-7074).
         *
         * Optional on purpose: the legacy adapters have no such signal, leave it
         * undefined, and keep their existing stock-based rule. Only set it from
         * an adapter whose backend actually answers the question.
         */
        orderable?: boolean;
    }

    export interface IShopActions {
        // Core functionality
        addPartToShopBasket(articleId: string, quantity: number, context?: ShopArticleContext): Promise<void>;
        getShopItemInfoForArticle(articleId: string, context?: ShopArticleContext): Promise<WidgetItem | null>;
        sendPriceRequestToShop?(articleId: string, context?: ShopArticleContext): Promise<void>;

        // Basket operations
        getBasket(): Promise<any>;
        getCartId?(): Promise<string | undefined>;
        redirectToBasket(cartId?: string): Promise<void>;

        // Optional operations
        getBasketIdForCurrentUser?(): string | undefined;
        getShopClient?(): Promise<any>;
    }

    // Apollo client type
    export interface ClientWithCache {
        client: ApolloClient<NormalizedCacheObject>;
        cache: ApolloCache<NormalizedCacheObject>;
    }
}
